import * as XLSX from "xlsx-js-style";

export const financialStatus = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");

const excelDate = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  if (!match) return null;
  const [, year, month, day] = match.map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  )
    return null;
  return (date.getTime() - Date.UTC(1899, 11, 30)) / 86400000;
};

const dateFromKey = (key) => {
  const match = String(key || "").match(/^(?:PRE_)?(\d{2})(\d{2})(\d{4})\d*$/);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
};

const bogotaDate = (now) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

export const buildPaymentWorkbook = (records, key, now = new Date()) => {
  const eligible = (Array.isArray(records) ? records : []).filter(
    (row) =>
      String(row.key_concil || "") === String(key) &&
      ["auto-liquidado", "conciliado-liquidar"].includes(financialStatus(row.status))
  );
  if (!eligible.length) return null;
  const loadDate = excelDate(bogotaDate(now));
  const data = eligible.map((row) => {
    let more = row.more;
    if (typeof more === "string") {
      try {
        more = JSON.parse(more);
      } catch (_) {
        more = null;
      }
    }
    const name = String(row.realName || row.name || more?.concesion || "")
      .trim()
      .toLocaleUpperCase("es-CO");
    const amount = row.value_final;
    return {
      "FECHA DEL CARGUE": loadDate,
      CONCESION: name,
      PEAJE: name,
      MONTO:
        amount != null && amount !== "" && Number.isFinite(Number(amount))
          ? Number(amount)
          : "Sin definir",
      DESCRIPCION:
        excelDate(more?.fecha || row.conciliation_date || dateFromKey(key)) ?? "Sin definir",
      NOTAS: "Recaudo Diario",
    };
  });
  const sheet = XLSX.utils.json_to_sheet(data);
  sheet["!cols"] = [22, 48, 48, 24, 24, 24].map((wch) => ({ wch }));
  sheet["!rows"] = [{ hpt: 30 }, ...data.map(() => ({ hpt: 24 }))];
  sheet["!autofilter"] = { ref: sheet["!ref"] };
  Object.entries(sheet).forEach(([address, cell]) => {
    if (address.startsWith("!")) return;
    const header = XLSX.utils.decode_cell(address).r === 0;
    cell.s = {
      font: { name: "Calibri", sz: 11, color: { rgb: header ? "FFFFFF" : "172B4D" }, bold: header },
      fill: { fgColor: { rgb: header ? "164858" : "FFFFFF" } },
      alignment: { vertical: "center", wrapText: header },
      border: { bottom: { style: "thin", color: { rgb: "E2E8F0" } } },
    };
    if (!header && cell.t === "n") {
      if (/^[AE]/.test(address)) cell.z = "dd/mm/yyyy";
      if (address.startsWith("D")) cell.z = '"$" #,##0.00';
    }
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Pagos");
  return workbook;
};
